// extracted by mini-css-extract-plugin
module.exports = {"container":"Charactaristics_container__wrj1z"};